export enum LotteryApplicationType {
  OTHER,
  WITHIN_APPLICATION_PERIOD,
  WITHOUT_APPLICATION_PERIOD,
}
